import axios from 'axios';
import storage from "./storage";
import $router from "./router.js"
import md5 from 'js-md5';
import Cookies from 'js-cookie'
import versionTood from './versionUpdate.js'
import Vue from 'vue'

// export const BASE_URL = '/api';
// export const BASE_URL = '';
//export const BASE_URL = 'http://192.168.1.181:8059/hdh_app_war_exploded/';
// export const BASE_URL = 'http://192.168.1.122:8024/cb-app';
let BASE=''
if (window.location.href.indexOf('http://192.168.1.87/') != -1||window.location.href.indexOf('localhost') != -1) {
	BASE = '';
} else{
	BASE = '/api';
}

const http = axios.create({
  baseURL: BASE,
  // timeout: 5000
})
export const BASE_URL=BASE
/**
 *request拦截器
 */
http.interceptors.request.use((config) => {
	Vue.prototype.$openLoading()
	versionTood.isNewVersion()
  // todo headers 添加token
  if (Cookies.get("token") !== undefined) {
    config.headers.authorization = Cookies.get("token");//把localStorage的token放在Authorization里
  }
  return config;


}, (err) => {
  Promise.reject(err)

})

// const autoLogin = function () {
//   http.get('/login', {
//     params: {
//       loginName: 'visitor',
//       password: md5('visitor@2020')
//     }

//   }).then(res => {

//   })
// }

/**
 * response拦截器
 */
http.interceptors.response.use(
  (response) => {
	  Vue.prototype.$openLoadingHide()
    // console.log(response, "response")
    const { code, message } = response.data;
    if (code == 600) {
      $router.push('/login')
	  
    }


    return response;
  }, (err) => {
	  Vue.prototype.$openLoadingHide()

    return Promise.reject(err)
  }
)

export default http
